var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreememo"},[_c('h1',[_vm._v("《用户数据采集安全协议说明》")]),_vm._v(" "+_vm._s(_vm.agreememo)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }